export default {
  checkout: {
    seo: {
      cartTitle: 'Panier d’excursions | AQUAMARINA TOURS',
      cartDescription: 'Votre panier d’excursions à Paraty. Ajoutez des sorties en goélette, en bateau à moteur et en jeep à votre liste et réservez via WhatsApp.',
    },
    cart: {
      item: 'article',
      items: 'articles',
      clear: 'Vider le panier',
      tourDate: 'Date de l’excursion :',
      review: 'Vérifiez les excursions sélectionnées et confirmez votre réservation avec un paiement sécurisé.',
      deposit: 'Acompte via PIX',
      remaining: 'Solde le jour de l’excursion',
      depositNote: 'L’acompte correspond à {{percent}} % du total, avec un minimum de R$ 20,00.',
      full: 'Paiement total via PIX',
      fullNote: 'Le montant total est payé maintenant pour garantir la réservation.',
      continuePayment: 'Continuer vers le paiement',
      clearConfirmTitle: 'Vider le panier ?',
      clearConfirmText: 'Tous les articles seront supprimés. Cette action est irréversible.',
      cancel: 'Annuler',
      clearConfirm: 'Vider',
    },
    modal: {
      titlePix: 'Payez l’acompte avec Pix',
      titleDetails: 'Coordonnées du responsable',
      close: 'Fermer',
      adults_one: '{{count}} adulte',
      adults_other: '{{count}} adultes',
      children_one: '{{count}} enfant',
      children_other: '{{count}} enfants',
      babies_one: '{{count}} bébé',
      babies_other: '{{count}} bébés',
      participants_one: '{{count}} participant',
      participants_other: '{{count}} participants',
      depositLabel: 'Acompte via Pix ({{percent}} %)',
      remainingNote: 'Le solde ({{amount}}) est payé le jour de l’excursion.',
      qrAlt: 'QR code Pix',
      scanHint: 'Scannez le QR code dans l’application de votre banque ou utilisez le code Pix copier-coller.',
      copied: 'Code copié !',
      copyPix: 'Copier le code Pix',
      waiting: 'En attente du paiement — la confirmation s’affichera ici automatiquement.',
      fillIn: 'Renseignez les coordonnées de la personne qui réserve.',
      fullName: 'Nom complet',
      fullNamePlaceholder: 'Prénom et nom',
      whatsapp: 'WhatsApp',
      ticketEmailHint: 'Votre billet arrivera à cette adresse email dès la confirmation de la réservation.',
      pickupLabel: 'Où venir vous chercher',
      pickupPlaceholder: 'Hôtel, pousada ou adresse à Paraty',
      pickupAgency: 'Embarquer à l’agence',
      pickupHint: 'Prise en charge gratuite de 10h20 à 11h00 dans le centre de Paraty (jusqu’à 3 km de l’agence). Le guide confirme l’heure sur WhatsApp.',
      pickupAgencyHint: 'Vous embarquez à l’agence : l’heure d’arrivée figure sur votre billet.',
      email: 'E-mail',
      emailPlaceholder: 'vous@exemple.com',
      cpf: 'CPF',
      requiredOnline: '(obligatoire pour payer en ligne)',
      talkWhatsApp: 'Contacter l’équipe sur WhatsApp',
      generatingPix: 'Génération du Pix…',
      payPix: 'Payer l’acompte de {{amount}} avec Pix',
      sendWhatsApp: 'Envoyer la réservation via WhatsApp',
      openingMp: 'Ouverture de Mercado Pago…',
      payCard: 'Je préfère payer par carte (Mercado Pago)',
      secure: 'Paiements traités en toute sécurité par Mercado Pago',
      errors: {
        fullName: 'Indiquez votre prénom et votre nom.',
        whatsapp: 'Indiquez un numéro WhatsApp avec l’indicatif régional.',
        email: 'Indiquez un e-mail valide.',
        cpf: 'CPF invalide.',
        pickup: 'Indiquez où venir vous chercher ou choisissez d’embarquer à l’agence.',
        offline: 'Le paiement en ligne ne fonctionne que sur le site publié (ou avec "npx netlify dev"). Vous pouvez envoyer la réservation via WhatsApp.',
        generic: 'Impossible de finaliser l’opération.',
        pixFailed: 'Impossible de générer le Pix.',
        paymentFailed: 'Impossible de lancer le paiement.',
      },
    },
    flow: {
      steps: { cart: 'Panier', holder: 'Responsable', payment: 'Paiement', confirm: 'Confirmation' },
      stepOf: 'Étape {{current}} sur {{total}}',
      titles: {
        payment: 'Comment souhaitez-vous payer ?',
        approved: 'Paiement approuvé',
        inProcess: 'Paiement en cours de vérification',
        rejected: 'Paiement non approuvé',
      },
      summary: {
        title: 'Récapitulatif de la réservation',
        show: 'Voir le récapitulatif',
        hide: 'Masquer le récapitulatif',
        total: 'Total',
        dueNow: 'Acompte prélevé maintenant ({{percent}} %)',
        dueNowPlain: 'Acompte prélevé maintenant',
        fullNow: 'Montant total prélevé maintenant',
        dueNowShort: 'Acompte maintenant',
        dueOnDay: 'Solde le jour de la sortie',
        date: 'Date',
        guests: 'Participants',
        empty: 'Votre sac est vide.',
      },
      document: {
        legend: 'Pièce d’identité',
        cpf: 'CPF',
        passport: 'Passeport',
        cpfHint: 'Chiffres uniquement ; le format est automatique.',
        passportNumber: 'Numéro de passeport',
        passportPlaceholder: 'Ex. : AB1234567',
        passportHint: 'Pour les visiteurs étrangers.',
        nationality: 'Pays du passeport',
        nationalityPlaceholder: 'Choisissez le pays',
        frequent: 'Les plus courants',
        allCountries: 'Tous les pays',
      },
      errors: {
        passport: 'Saisissez le numéro de passeport (5 à 20 lettres ou chiffres).',
        nationality: 'Choisissez le pays du passeport.',
        pixNeedsCpf: 'Mercado Pago a exigé un CPF pour ce Pix. Indiquez un CPF ou confirmez votre réservation sur WhatsApp.',
        cardSdk: 'Le formulaire sécurisé de carte n’a pas pu se charger. Vérifiez votre connexion et réessayez, ou payez via le checkout Mercado Pago.',
      },
      actions: {
        continue: 'Continuer vers le paiement',
        back: 'Retour',
        editDetails: 'Modifier',
        whatsappInstead: 'Je préfère envoyer ma réservation par WhatsApp',
        retry: 'Réessayer',
        tryAnotherCard: 'Essayer une autre carte',
        payWithPix: 'Payer avec Pix',
        payWithCard: 'Payer par carte bancaire',
        newPix: 'Générer un nouveau Pix',
        showPix: 'Afficher le QR code Pix',
        viewReservation: 'Voir ma réservation',
        otherMethod: 'Autre moyen de paiement',
      },
      whatsappNote: 'Pour WhatsApp, le nom et le numéro suffisent.',
      tabs: { label: 'Moyen de paiement', pix: 'Pix', card: 'Carte bancaire' },
      pix: {
        instant: 'Confirmation immédiate',
        validity: 'QR code valable 30 minutes',
        anyBank: 'Fonctionne dans l’app de toute banque brésilienne',
        passportNote: 'Avec un passeport, certaines banques et certains comptes exigent un CPF pour Pix. Si cela ne fonctionne pas, confirmez votre réservation sur WhatsApp.',
        expiresIn: 'Expire dans {{time}}',
        expired: 'Ce Pix a expiré. Générez un nouveau code pour payer.',
        paste: 'Pix copier-coller',
      },
      card: {
        lead: 'Acompte de {{amount}} en 3 fois maximum. Les données de carte vont directement à Mercado Pago, sans passer par notre site.',
        loading: 'Chargement du formulaire sécurisé…',
        processing: 'Traitement du paiement…',
        fallbackNote: 'Vous serez redirigé vers le checkout sécurisé de Mercado Pago pour payer par carte (jusqu’à 3 fois), puis ramené sur le site.',
        fallbackButton: 'Payer {{amount}} par carte sur Mercado Pago',
      },
      result: {
        approvedDesc: 'Votre acompte est payé et votre réservation est confirmée. Ouverture de votre confirmation…',
        inProcessDesc: 'Mercado Pago vérifie le paiement. Vous recevrez la réponse par email, généralement en quelques minutes.',
        rejectedDesc: 'Rien n’a été débité. Vous pouvez essayer une autre carte ou payer avec Pix.',
        paymentId: 'Paiement n° {{id}}',
      },
      statusDetail: {
        accredited: 'Paiement approuvé.',
        pending_contingency: 'Nous traitons le paiement. Vous recevrez le résultat par email sous 2 jours ouvrés.',
        pending_review_manual: 'Le paiement est en cours de vérification. Vous recevrez le résultat par email sous 2 jours ouvrés.',
        cc_rejected_bad_filled_card_number: 'Vérifiez le numéro de la carte.',
        cc_rejected_bad_filled_date: 'Vérifiez la date d’expiration de la carte.',
        cc_rejected_bad_filled_other: 'Vérifiez les informations de la carte.',
        cc_rejected_bad_filled_security_code: 'Vérifiez le code de sécurité (CVV) de la carte.',
        cc_rejected_blacklist: 'Cette carte ne peut pas être utilisée. Utilisez une autre carte ou Pix.',
        cc_rejected_call_for_authorize: 'Votre banque doit autoriser ce paiement. Appelez-la puis réessayez.',
        cc_rejected_card_disabled: 'Cette carte n’est pas active. Appelez votre banque pour l’activer ou utilisez une autre carte.',
        cc_rejected_card_error: 'Le paiement n’a pas pu être traité. Réessayez ou utilisez une autre carte.',
        cc_rejected_duplicated_payment: 'Vous avez déjà effectué un paiement de ce montant. Pour payer à nouveau, utilisez une autre carte ou Pix.',
        cc_rejected_high_risk: 'Le paiement a été refusé pour des raisons de sécurité. Utilisez une autre carte ou payez avec Pix.',
        cc_rejected_insufficient_amount: 'Le plafond de la carte est insuffisant. Utilisez une autre carte ou Pix.',
        cc_rejected_invalid_installments: 'Cette carte n’accepte pas ce nombre d’échéances. Payez en une fois ou utilisez une autre carte.',
        cc_rejected_max_attempts: 'Vous avez atteint la limite de tentatives. Utilisez une autre carte ou Pix.',
        cc_rejected_other_reason: 'Votre banque n’a pas approuvé le paiement. Utilisez une autre carte ou Pix.',
        default: 'Le paiement n’a pas été approuvé. Utilisez une autre carte ou payez avec Pix.',
      },
    },
    paymentReturn: {
      loadingTitle: 'Vérification de votre paiement…',
      approvedTitle: 'Paiement approuvé',
      pendingTitle: 'Paiement en attente',
      failedTitle: 'Paiement non finalisé',
      loadingDesc: 'Nous confirmons le résultat auprès de Mercado Pago.',
      approvedDesc: 'Votre réservation est confirmée. Envoyez la confirmation via WhatsApp pour que l’équipe vous réserve vos places.',
      pendingDesc: 'Mercado Pago traite encore le paiement. Dès qu’il sera approuvé, votre réservation sera confirmée.',
      failedDesc: 'Aucun débit n’a été confirmé. Vous pouvez réessayer ou contacter l’équipe sur WhatsApp.',
      emailSent: 'Nous avons envoyé votre ticket en PDF à l’adresse e-mail indiquée.',
      emailFailed: 'La réservation est confirmée, mais nous n’avons pas pu envoyer l’e-mail. Vous pouvez ouvrir le ticket ci-dessous.',
      sendConfirmation: 'Envoyer la confirmation via WhatsApp',
      talkTeam: 'Contacter l’équipe sur WhatsApp',
      viewTicket: 'Voir mon ticket',
      backToCart: 'Retour au panier',
      confirmedTitle: 'Réservation confirmée !',
      thanks: 'Merci, {{name}} ! Votre place pour {{tour}} est réservée. À bientôt à bord.',
      ticketByEmail: 'Votre billet arrive à {{email}}, et vous pouvez aussi le télécharger en PDF.',
      summaryDate: 'Date',
      summaryPeople: 'Personnes',
      summaryPaid: 'Acompte payé',
      summaryRemaining: 'Solde le jour même',
      ticketHeadline: 'RÉSERVATION CONFIRMÉE',
      ticketDate: 'Date',
      ticketPeople: 'Personnes',
      ticketCode: 'Code',
      ticketPaid: 'PIX ✓ PAYÉ',
    },
    ticket: {
      notFound: 'Ticket introuvable',
      backToSite: 'Retour au site',
      title: 'Ticket de réservation',
      holder: 'RESPONSABLE',
      whatsapp: 'WhatsApp : {{phone}}',
      confirmed: 'CONFIRMÉE',
      participants_one: '{{count}} participant',
      participants_other: '{{count}} participants',
      total: 'Total',
      depositPaid: 'Acompte payé',
      downloadPdf: 'Télécharger le PDF',
      addWallet: 'Ajouter au Wallet',
      walletAlert: 'Le Wallet nécessite de configurer Apple Wallet ou Google Wallet comme émetteur.',
    },
  },
};
